import React from 'react';
import { activityNeutralButtonClass } from 'features/activity/styles/dataTableStyles';

/**
 * The one footer every list in the app ends with: how many rows are showing
 * on the left, "Load more" in the middle while there are more to fetch.
 *
 *   shown       rows on screen
 *   total       rows that match, when the server knows (else "N loaded")
 *   hasMore     whether "Load more" appears
 *   loading     the button says "Loading…" and waits
 *   onLoadMore  fetch the next page
 *   note        replaces the count text when a list has something better to say
 */
export default function TableFooter({ shown = 0, total = null, hasMore = false, loading = false, onLoadMore, note = null, className = '' }) {
  if (!shown && !note) return null;
  const count = note != null
    ? note
    : total != null && total >= shown
      ? `${Number(shown).toLocaleString()} of ${Number(total).toLocaleString()}`
      : `${Number(shown).toLocaleString()} loaded`;
  return (
    <div className={`relative flex min-h-[40px] items-center pt-2 ${className}`} style={{ fontFamily: 'Inter, sans-serif' }}>
      <span className="text-[11px] tabular-nums text-[color:var(--text-muted)]">{count}</span>
      {hasMore && onLoadMore ? (
        <div className="absolute left-1/2 -translate-x-1/2">
          <button type="button" disabled={loading} onClick={onLoadMore} className={activityNeutralButtonClass}>
            {loading ? 'Loading…' : 'Load more'}
          </button>
        </div>
      ) : null}
    </div>
  );
}
